import Text from 'components/shared/Text'
import { SelfcareShortcutWrapper } from './styles'

interface ShortcutTileSelfcareProps {
    icon: string
    alt: string
    text: string
    onClick: () => void
    testId?: string
}

const ShortcutTileSelfcare = ({
    icon,
    alt,
    text,
    onClick,
    testId,
}: ShortcutTileSelfcareProps) => (
    <SelfcareShortcutWrapper
        pt={[16, 24]}
        pb={[16, 24]}
        pl={[16, 8]}
        pr={[16, 8]}
        gap={[10, 0]}
        justify={['flex-start', 'space-between']}
        align="center"
        direction={['row', 'column']}
        onClick={onClick}
        data-testid={testId}
    >
        <img src={icon} alt={alt} />
        <Text
            variant="body"
            color="grayscale_900"
            align="center"
            mt={[0, 12]}
            mb={[0, 12]}
        >
            {text}
        </Text>
    </SelfcareShortcutWrapper>
)

export default ShortcutTileSelfcare
